// AloVault brand — mirrors the mobile apps: brand blue #1B5EA8 (interactive),
// navy #174E84 (chrome/sidebar, secondary), tile blue #DCEAF8 (pale accents,
// repurposed "tertiary"), light-gray canvas #F7F7F7. success/error are
// status-only and intentionally NOT brand colors.
export const colors ={
        primary: {
            light: '#4E86C6',
            main: '#1B5EA8',
            dark: '#12406F',
            contrastText: '#fff'
        },
        secondary: {
            light: '#3E6FA0',
            main: '#174E84',
            dark: '#0F3557'
        },
        tertiary: {
            light: '#EAF2FB',
            main: '#DCEAF8',
            dark: '#A9C7E8'
        },
        success: {
            main: '#8bbc5c'
        },
        error: {
            light: '#fcc7c3',
            main: '#f44336'
        },
        bg: {
            main: '#F7F7F7'
        },
        font:{
            md: '#444',
            dark: '#212121',
            light: '#757575'
        },
        grey: {
            dark: '#3e4953',
            light: '#efeff5'
        }
}
